import { render, staticRenderFns } from "./setFuncModel.vue?vue&type=template&id=4b403a28&scoped=true&"
import script from "./setFuncModel.vue?vue&type=script&lang=js&"
export * from "./setFuncModel.vue?vue&type=script&lang=js&"
import style0 from "./setFuncModel.vue?vue&type=style&index=0&id=4b403a28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b403a28",
  null
  
)

export default component.exports